import React, { FC } from "react";
import { Hero } from "@/modules/organisms";
import "./index.scss";

const Main: FC = () => {
  return <Hero />;
};

export default Main;
